export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const PUSH_NAVIGATION = 'PUSH_NAVIGATION';
export const POP_NAVIGATION = 'POP_NAVIGATION';
export const RESET_NAVIGATION = 'RESET_NAVIGATION';
export const BACK_NAVIGATION = 'BACK_NAVIGATION';
export const SET_VERSION = 'SET_VERSION';
